import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
import { StringBuildermazzzhj6kkai as StringBuilder } from '../text/StringBuilderJs.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../Unit.mjs';
import { appendElement7nmjunfw9r4 as appendElement } from '../text/Appendable.mjs';
import {
  emptySetcxexqki71qfa as emptySet,
  optimizeReadOnlySetbkgqv9johc5 as optimizeReadOnlySet,
} from './Sets.mjs';
import {
  KtList3hktaavzmj137 as KtList,
  Collection1k04j3hzsbod0 as Collection,
} from './Collections.mjs';
import {
  isInterface3d6p8outrmvmk as isInterface,
  isArray1hxjqtqy632bc as isArray,
} from '../js/typeCheckUtils.mjs';
import {
  setOf1u3mizs95ngxo as setOf,
  mapCapacity1h45rc3eh9p2l as mapCapacity,
  listOfvhqybd2zx248 as listOf,
  copyToArray2j022khrow2yi as copyToArray,
  sortWith4fnm6b3vw03s as sortWith,
  sort15ai02l4kxbfa as sort,
} from './collectionJs.mjs';
import { LinkedHashSet2tkztfx86kyx2 as LinkedHashSet } from './LinkedHashSet.mjs';
import {
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  NoSuchElementException679xzhnp5bpj as NoSuchElementException,
} from '../exceptions.mjs';
import {
  toString1pkumu07cwy4m as toString,
  equals2au1ep9vhcato as equals,
} from '../js/coreRuntime.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from './ArrayListJs.mjs';
import {
  emptyList1g2z5xcrvp2zy as emptyList,
  optimizeReadOnlyList2kolyxeo5m6k3 as optimizeReadOnlyList,
  get_lastIndex1yw0x4k50k51w as get_lastIndex,
} from './CollectionsKt.mjs';
import { RandomAccess1jbw8sdogqb8x as RandomAccess } from './RandomAccess.mjs';
import { reversenv3adafjrtzo as reverse } from './_CollectionsJs.mjs';
import {
  addAll1k27qatfgp3k5 as addAll,
  addAll3rgorw6ix9mgp as addAll_0,
  convertToListIfNotCollection2y7m25iq802o0 as convertToListIfNotCollection,
} from './MutableCollections.mjs';
import {
  coerceAtLeast2bkz8m9ik7hep as coerceAtLeast,
  coerceAtMost322komnqp70ag as coerceAtMost,
} from '../ranges/_Ranges.mjs';
import {
  IndexingIterable2a6g9uso7i6wu as IndexingIterable,
  collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault,
} from './Iterables.mjs';
import { to2cs3ny02qtbcb as to } from '../Tuples.mjs';
import { HashSet2dzve9y63nf0v as HashSet } from './HashSet.mjs';
import { booleanArray2jdug9b51huk7 as booleanArray } from '../js/arrays.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../hacks.mjs';
import {
  sortWith23lt7r6b8svqd as sortWith_0,
  asList2ho2pewtsfvv as asList,
  sort1opyk0uibi7i3 as sort_0,
} from './_ArraysJs.mjs';
import {
  checkWindowSizeStepcg5bise2nnst as checkWindowSizeStep,
  windowedIterator1l52d653czu3r as windowedIterator,
} from './SlidingWindow.mjs';
import { compareTo3ankvs086tmwq as compareTo } from '../js/compareTo.mjs';
import { Sequence1quqbxersk0bb as Sequence } from '../sequences/Sequence.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function joinToString(_this__u8e3s4, separator, prefix, postfix, limit, truncated, transform) {
  separator = separator === VOID ? ', ' : separator;
  prefix = prefix === VOID ? '' : prefix;
  postfix = postfix === VOID ? '' : postfix;
  limit = limit === VOID ? -1 : limit;
  truncated = truncated === VOID ? '...' : truncated;
  transform = transform === VOID ? null : transform;
  return joinTo(_this__u8e3s4, StringBuilder().new_kotlin_text_StringBuilder_u46mrb_k$(), separator, prefix, postfix, limit, truncated, transform).toString();
}
function joinTo(_this__u8e3s4, buffer, separator, prefix, postfix, limit, truncated, transform) {
  separator = separator === VOID ? ', ' : separator;
  prefix = prefix === VOID ? '' : prefix;
  postfix = postfix === VOID ? '' : postfix;
  limit = limit === VOID ? -1 : limit;
  truncated = truncated === VOID ? '...' : truncated;
  transform = transform === VOID ? null : transform;
  buffer.append_jgojdo_k$(prefix);
  var count = 0;
  var _iterator__ex2g4s = _this__u8e3s4.iterator_jk1svi_k$();
  $l$loop: while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var element = _iterator__ex2g4s.next_20eer_k$();
    count = count + 1 | 0;
    if (count > 1) {
      buffer.append_jgojdo_k$(separator);
    }
    if (limit < 0 || count <= limit) {
      appendElement(buffer, element, transform);
    } else
      break $l$loop;
  }
  if (limit >= 0 && count > limit) {
    buffer.append_jgojdo_k$(truncated);
  }
  buffer.append_jgojdo_k$(postfix);
  return buffer;
}
function toSet(_this__u8e3s4) {
  if (isInterface(_this__u8e3s4, Collection())) {
    var tmp;
    switch (_this__u8e3s4.get_size_woubt6_k$()) {
      case 0:
        tmp = emptySet();
        break;
      case 1:
        var tmp_0;
        if (isInterface(_this__u8e3s4, KtList())) {
          tmp_0 = _this__u8e3s4.get_c1px32_k$(0);
        } else {
          tmp_0 = _this__u8e3s4.iterator_jk1svi_k$().next_20eer_k$();
        }

        tmp = setOf(tmp_0);
        break;
      default:
        tmp = toCollection(_this__u8e3s4, LinkedHashSet().new_kotlin_collections_LinkedHashSet_wmub5z_k$(mapCapacity(_this__u8e3s4.get_size_woubt6_k$())));
        break;
    }
    return tmp;
  }
  return optimizeReadOnlySet(toCollection(_this__u8e3s4, LinkedHashSet().new_kotlin_collections_LinkedHashSet_ahyf7j_k$()));
}
function drop(_this__u8e3s4, n) {
  // Inline function 'kotlin.require' call
  if (!(n >= 0)) {
    var message = 'Requested element count ' + n + ' is less than zero.';
    throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message));
  }
  if (n === 0)
    return toList(_this__u8e3s4);
  var list;
  if (isInterface(_this__u8e3s4, Collection())) {
    var resultSize = _this__u8e3s4.get_size_woubt6_k$() - n | 0;
    if (resultSize <= 0)
      return emptyList();
    if (resultSize === 1)
      return listOf(last_0(_this__u8e3s4));
    list = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(resultSize);
    if (isInterface(_this__u8e3s4, KtList())) {
      if (isInterface(_this__u8e3s4, RandomAccess())) {
        var inductionVariable = n;
        var last = _this__u8e3s4.get_size_woubt6_k$();
        if (inductionVariable < last)
          do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            list.add_utx5q5_k$(_this__u8e3s4.get_c1px32_k$(index));
          }
           while (inductionVariable < last);
      } else {
        // Inline function 'kotlin.collections.iterator' call
        var _iterator__ex2g4s = _this__u8e3s4.listIterator_70e65o_k$(n);
        while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
          var item = _iterator__ex2g4s.next_20eer_k$();
          list.add_utx5q5_k$(item);
        }
      }
      return list;
    }
  } else {
    list = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
  }
  var count = 0;
  var _iterator__ex2g4s_0 = _this__u8e3s4.iterator_jk1svi_k$();
  while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
    var item_0 = _iterator__ex2g4s_0.next_20eer_k$();
    if (count >= n)
      list.add_utx5q5_k$(item_0);
    else {
      count = count + 1 | 0;
    }
  }
  return optimizeReadOnlyList(list);
}
function last(_this__u8e3s4) {
  if (_this__u8e3s4.isEmpty_y1axqb_k$())
    throw NoSuchElementException().new_kotlin_NoSuchElementException_eborbh_k$('List is empty.');
  return _this__u8e3s4.get_c1px32_k$(get_lastIndex(_this__u8e3s4));
}
function asSequence(_this__u8e3s4) {
  // Inline function 'kotlin.sequences.Sequence' call
  return new (asSequence$$inlined$Sequence$1())(_this__u8e3s4);
}
function reversed(_this__u8e3s4) {
  var tmp;
  if (isInterface(_this__u8e3s4, Collection())) {
    tmp = _this__u8e3s4.get_size_woubt6_k$() <= 1;
  } else {
    tmp = false;
  }
  if (tmp)
    return toList(_this__u8e3s4);
  var list = toMutableList_0(_this__u8e3s4);
  reverse(list);
  return list;
}
function plus(_this__u8e3s4, elements) {
  if (isInterface(elements, Collection())) {
    var result = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(_this__u8e3s4.get_size_woubt6_k$() + elements.get_size_woubt6_k$() | 0);
    result.addAll_4lah1e_k$(_this__u8e3s4);
    result.addAll_4lah1e_k$(elements);
    return result;
  } else {
    var result_0 = ArrayList().new_kotlin_collections_ArrayList_603np_k$(_this__u8e3s4);
    addAll(result_0, elements);
    return result_0;
  }
}
function lastOrNull(_this__u8e3s4) {
  return _this__u8e3s4.isEmpty_y1axqb_k$() ? null : _this__u8e3s4.get_c1px32_k$(_this__u8e3s4.get_size_woubt6_k$() - 1 | 0);
}
function plus_0(_this__u8e3s4, element) {
  var result = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(_this__u8e3s4.get_size_woubt6_k$() + 1 | 0);
  result.addAll_4lah1e_k$(_this__u8e3s4);
  result.add_utx5q5_k$(element);
  return result;
}
function dropLast(_this__u8e3s4, n) {
  // Inline function 'kotlin.require' call
  if (!(n >= 0)) {
    var message = 'Requested element count ' + n + ' is less than zero.';
    throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message));
  }
  return take(_this__u8e3s4, coerceAtLeast(_this__u8e3s4.get_size_woubt6_k$() - n | 0, 0));
}
function firstOrNull(_this__u8e3s4) {
  return _this__u8e3s4.isEmpty_y1axqb_k$() ? null : _this__u8e3s4.get_c1px32_k$(0);
}
function getOrNull(_this__u8e3s4, index) {
  return (0 <= index ? index < _this__u8e3s4.get_size_woubt6_k$() : false) ? _this__u8e3s4.get_c1px32_k$(index) : null;
}
function toList(_this__u8e3s4) {
  if (isInterface(_this__u8e3s4, Collection())) {
    var tmp;
    switch (_this__u8e3s4.get_size_woubt6_k$()) {
      case 0:
        tmp = emptyList();
        break;
      case 1:
        var tmp_0;
        if (isInterface(_this__u8e3s4, KtList())) {
          tmp_0 = _this__u8e3s4.get_c1px32_k$(0);
        } else {
          tmp_0 = _this__u8e3s4.iterator_jk1svi_k$().next_20eer_k$();
        }

        tmp = listOf(tmp_0);
        break;
      default:
        tmp = toMutableList(_this__u8e3s4);
        break;
    }
    return tmp;
  }
  return optimizeReadOnlyList(toMutableList_0(_this__u8e3s4));
}
function singleOrNull(_this__u8e3s4) {
  return _this__u8e3s4.get_size_woubt6_k$() === 1 ? _this__u8e3s4.get_c1px32_k$(0) : null;
}
function indexOf(_this__u8e3s4, element) {
  return _this__u8e3s4.indexOf_si1fv9_k$(element);
}
function firstOrNull_0(_this__u8e3s4) {
  if (isInterface(_this__u8e3s4, KtList())) {
    if (_this__u8e3s4.isEmpty_y1axqb_k$())
      return null;
    else
      return _this__u8e3s4.get_c1px32_k$(0);
  } else {
    var iterator = _this__u8e3s4.iterator_jk1svi_k$();
    if (!iterator.hasNext_bitz1p_k$())
      return null;
    return iterator.next_20eer_k$();
  }
}
function take(_this__u8e3s4, n) {
  // Inline function 'kotlin.require' call
  if (!(n >= 0)) {
    var message = 'Requested element count ' + n + ' is less than zero.';
    throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message));
  }
  if (n === 0)
    return emptyList();
  if (isInterface(_this__u8e3s4, Collection())) {
    if (n >= _this__u8e3s4.get_size_woubt6_k$())
      return toList(_this__u8e3s4);
    if (n === 1)
      return listOf(first_0(_this__u8e3s4));
  }
  var count = 0;
  var list = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(n);
  var _iterator__ex2g4s = _this__u8e3s4.iterator_jk1svi_k$();
  $l$loop: while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var item = _iterator__ex2g4s.next_20eer_k$();
    list.add_utx5q5_k$(item);
    count = count + 1 | 0;
    if (count === n)
      break $l$loop;
  }
  return optimizeReadOnlyList(list);
}
function first(_this__u8e3s4) {
  if (_this__u8e3s4.isEmpty_y1axqb_k$())
    throw NoSuchElementException().new_kotlin_NoSuchElementException_eborbh_k$('List is empty.');
  return _this__u8e3s4.get_c1px32_k$(0);
}
function withIndex(_this__u8e3s4) {
  return new (IndexingIterable())(() => _this__u8e3s4.iterator_jk1svi_k$());
}
function toMutableList(_this__u8e3s4) {
  return ArrayList().new_kotlin_collections_ArrayList_603np_k$(_this__u8e3s4);
}
function zip(_this__u8e3s4, other) {
  // Inline function 'kotlin.collections.zip' call
  var first = _this__u8e3s4.iterator_jk1svi_k$();
  var second = other.iterator_jk1svi_k$();
  var tmp0 = collectionSizeOrDefault(_this__u8e3s4, 10);
  // Inline function 'kotlin.comparisons.minOf' call
  var b = collectionSizeOrDefault(other, 10);
  var tmp$ret$1 = Math.min(tmp0, b);
  var list = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(tmp$ret$1);
  while (first.hasNext_bitz1p_k$() && second.hasNext_bitz1p_k$()) {
    var tmp0_0 = first.next_20eer_k$();
    var t2 = second.next_20eer_k$();
    var tmp$ret$2 = to(tmp0_0, t2);
    list.add_utx5q5_k$(tmp$ret$2);
  }
  return list;
}
function distinct(_this__u8e3s4) {
  return toList(toMutableSet(_this__u8e3s4));
}
function single(_this__u8e3s4) {
  var tmp;
  switch (_this__u8e3s4.get_size_woubt6_k$()) {
    case 0:
      throw NoSuchElementException().new_kotlin_NoSuchElementException_eborbh_k$('List is empty.');
    case 1:
      tmp = _this__u8e3s4.get_c1px32_k$(0);
      break;
    default:
      throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$('List has more than one element.');
  }
  return tmp;
}
function toHashSet(_this__u8e3s4) {
  return toCollection(_this__u8e3s4, HashSet().new_kotlin_collections_HashSet_9nbh5e_k$(mapCapacity(collectionSizeOrDefault(_this__u8e3s4, 12))));
}
function toBooleanArray(_this__u8e3s4) {
  var result = booleanArray(_this__u8e3s4.get_size_woubt6_k$());
  var index = 0;
  var _iterator__ex2g4s = _this__u8e3s4.iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var element = _iterator__ex2g4s.next_20eer_k$();
    var _unary__edvuaz = index;
    index = _unary__edvuaz + 1 | 0;
    result[_unary__edvuaz] = element;
  }
  return result;
}
function sortedWith(_this__u8e3s4, comparator) {
  if (isInterface(_this__u8e3s4, Collection())) {
    if (_this__u8e3s4.get_size_woubt6_k$() <= 1)
      return toList(_this__u8e3s4);
    // Inline function 'kotlin.collections.toTypedArray' call
    var tmp = copyToArray(_this__u8e3s4);
    // Inline function 'kotlin.apply' call
    var this_0 = isArray(tmp) ? tmp : THROW_CCE();
    sortWith_0(this_0, comparator);
    return asList(this_0);
  }
  // Inline function 'kotlin.apply' call
  var this_1 = toMutableList_0(_this__u8e3s4);
  sortWith(this_1, comparator);
  return this_1;
}
function filterNotNull(_this__u8e3s4) {
  return filterNotNullTo(_this__u8e3s4, ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$());
}
function sorted(_this__u8e3s4) {
  if (isInterface(_this__u8e3s4, Collection())) {
    if (_this__u8e3s4.get_size_woubt6_k$() <= 1)
      return toList(_this__u8e3s4);
    // Inline function 'kotlin.collections.toTypedArray' call
    var tmp = copyToArray(_this__u8e3s4);
    // Inline function 'kotlin.apply' call
    var this_0 = isArray(tmp) ? tmp : THROW_CCE();
    sort_0(this_0);
    return asList(this_0);
  }
  // Inline function 'kotlin.apply' call
  var this_1 = toMutableList_0(_this__u8e3s4);
  sort(this_1);
  return this_1;
}
function chunked(_this__u8e3s4, size) {
  return windowed(_this__u8e3s4, size, size, true);
}
function toCollection(_this__u8e3s4, destination) {
  var _iterator__ex2g4s = _this__u8e3s4.iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var item = _iterator__ex2g4s.next_20eer_k$();
    destination.add_utx5q5_k$(item);
  }
  return destination;
}
function last_0(_this__u8e3s4) {
  if (isInterface(_this__u8e3s4, KtList()))
    return last(_this__u8e3s4);
  else {
    var iterator = _this__u8e3s4.iterator_jk1svi_k$();
    if (!iterator.hasNext_bitz1p_k$())
      throw NoSuchElementException().new_kotlin_NoSuchElementException_eborbh_k$('Collection is empty.');
    var last_0 = iterator.next_20eer_k$();
    while (iterator.hasNext_bitz1p_k$())
      last_0 = iterator.next_20eer_k$();
    return last_0;
  }
}
function toMutableList_0(_this__u8e3s4) {
  if (isInterface(_this__u8e3s4, Collection()))
    return toMutableList(_this__u8e3s4);
  return toCollection(_this__u8e3s4, ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$());
}
function first_0(_this__u8e3s4) {
  if (isInterface(_this__u8e3s4, KtList()))
    return first(_this__u8e3s4);
  else {
    var iterator = _this__u8e3s4.iterator_jk1svi_k$();
    if (!iterator.hasNext_bitz1p_k$())
      throw NoSuchElementException().new_kotlin_NoSuchElementException_eborbh_k$('Collection is empty.');
    return iterator.next_20eer_k$();
  }
}
function toMutableSet(_this__u8e3s4) {
  var tmp;
  if (isInterface(_this__u8e3s4, Collection())) {
    tmp = LinkedHashSet().new_kotlin_collections_LinkedHashSet_2u8q9r_k$(_this__u8e3s4);
  } else {
    tmp = toCollection(_this__u8e3s4, LinkedHashSet().new_kotlin_collections_LinkedHashSet_ahyf7j_k$());
  }
  return tmp;
}
function filterNotNullTo(_this__u8e3s4, destination) {
  var _iterator__ex2g4s = _this__u8e3s4.iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var element = _iterator__ex2g4s.next_20eer_k$();
    if (!(element == null)) {
      destination.add_utx5q5_k$(element);
    }
  }
  return destination;
}
function windowed(_this__u8e3s4, size, step, partialWindows) {
  step = step === VOID ? 1 : step;
  partialWindows = partialWindows === VOID ? false : partialWindows;
  checkWindowSizeStep(size, step);
  var tmp;
  if (isInterface(_this__u8e3s4, RandomAccess())) {
    tmp = isInterface(_this__u8e3s4, KtList());
  } else {
    tmp = false;
  }
  if (tmp) {
    var thisSize = _this__u8e3s4.get_size_woubt6_k$();
    var resultCapacity = (thisSize / step | 0) + ((thisSize % step | 0) === 0 ? 0 : 1) | 0;
    var result = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(resultCapacity);
    var index = 0;
    $l$loop: while (0 <= index ? index < thisSize : false) {
      var windowSize = coerceAtMost(size, thisSize - index | 0);
      if (windowSize < size && !partialWindows)
        break $l$loop;
      // Inline function 'kotlin.collections.List' call
      // Inline function 'kotlin.collections.MutableList' call
      var list = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(windowSize);
      // Inline function 'kotlin.repeat' call
      var inductionVariable = 0;
      if (inductionVariable < windowSize)
        do {
          var index_0 = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var tmp$ret$4 = _this__u8e3s4.get_c1px32_k$(index_0 + index | 0);
          list.add_utx5q5_k$(tmp$ret$4);
        }
         while (inductionVariable < windowSize);
      result.add_utx5q5_k$(list);
      index = index + step | 0;
    }
    return result;
  }
  var result_0 = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
  // Inline function 'kotlin.collections.forEach' call
  // Inline function 'kotlin.collections.iterator' call
  var _iterator__ex2g4s = windowedIterator(_this__u8e3s4.iterator_jk1svi_k$(), size, step, partialWindows, false);
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var element = _iterator__ex2g4s.next_20eer_k$();
    result_0.add_utx5q5_k$(element);
  }
  return result_0;
}
function single_0(_this__u8e3s4) {
  if (isInterface(_this__u8e3s4, KtList()))
    return single(_this__u8e3s4);
  else {
    var iterator = _this__u8e3s4.iterator_jk1svi_k$();
    if (!iterator.hasNext_bitz1p_k$())
      throw NoSuchElementException().new_kotlin_NoSuchElementException_eborbh_k$('Collection is empty.');
    var single_0 = iterator.next_20eer_k$();
    if (iterator.hasNext_bitz1p_k$())
      throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$('Collection has more than one element.');
    return single_0;
  }
}
function minOrNull(_this__u8e3s4) {
  var iterator = _this__u8e3s4.iterator_jk1svi_k$();
  if (!iterator.hasNext_bitz1p_k$())
    return null;
  var min = iterator.next_20eer_k$();
  while (iterator.hasNext_bitz1p_k$()) {
    var e = iterator.next_20eer_k$();
    if (compareTo(min, e) > 0)
      min = e;
  }
  return min;
}
function maxWithOrNull(_this__u8e3s4, comparator) {
  var iterator = _this__u8e3s4.iterator_jk1svi_k$();
  if (!iterator.hasNext_bitz1p_k$())
    return null;
  var max = iterator.next_20eer_k$();
  while (iterator.hasNext_bitz1p_k$()) {
    var e = iterator.next_20eer_k$();
    if (comparator.compare(max, e) < 0)
      max = e;
  }
  return max;
}
function plus_1(_this__u8e3s4, elements) {
  var result = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(_this__u8e3s4.get_size_woubt6_k$() + 10 | 0);
  result.addAll_4lah1e_k$(_this__u8e3s4);
  addAll_0(result, elements);
  return result;
}
function minus(_this__u8e3s4, element) {
  var result = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(_this__u8e3s4, 10));
  var removed = false;
  // Inline function 'kotlin.collections.filterTo' call
  var _iterator__ex2g4s = _this__u8e3s4.iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var element_0 = _iterator__ex2g4s.next_20eer_k$();
    var tmp;
    if (!removed && equals(element_0, element)) {
      removed = true;
      tmp = false;
    } else {
      tmp = true;
    }
    if (tmp) {
      result.add_utx5q5_k$(element_0);
    }
  }
  return result;
}
function intersect(_this__u8e3s4, other) {
  var otherCollection = convertToListIfNotCollection(other);
  // Inline function 'kotlin.collections.mutableSetOf' call
  var set = LinkedHashSet().new_kotlin_collections_LinkedHashSet_ahyf7j_k$();
  var _iterator__ex2g4s = _this__u8e3s4.iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var e = _iterator__ex2g4s.next_20eer_k$();
    if (otherCollection.contains_aljjnj_k$(e)) {
      set.add_utx5q5_k$(e);
    }
  }
  return set;
}
function union(_this__u8e3s4, other) {
  var set = toMutableSet(_this__u8e3s4);
  addAll(set, other);
  return set;
}
var asSequence$$inlined$Sequence$1Class;
function asSequence$$inlined$Sequence$1() {
  if (asSequence$$inlined$Sequence$1Class === VOID) {
    class $ {
      constructor($this_asSequence) {
        this.$this_asSequence_1 = $this_asSequence;
      }
      iterator_jk1svi_k$() {
        return this.$this_asSequence_1.iterator_jk1svi_k$();
      }
    }
    initMetadataForClass($, VOID, VOID, VOID, [Sequence()]);
    asSequence$$inlined$Sequence$1Class = $;
  }
  return asSequence$$inlined$Sequence$1Class;
}
//region block: exports
export {
  asSequence as asSequence2phdjljfh9jhx,
  chunked as chunked1umgsyuj0x9u1,
  distinct as distinct10qe1scfdvu5k,
  dropLast as dropLast1vpiyky649o34,
  drop as drop3na99dw9feawf,
  filterNotNull as filterNotNull3qfgcwmxhwfxe,
  firstOrNull as firstOrNull1982767dljvdy,
  firstOrNull_0 as firstOrNullf6vlo6vdgu1e,
  first as first58ocm7j58k3q,
  first_0 as first28gmhyvs4kf06,
  getOrNull as getOrNull1go7ef9ldk0df,
  indexOf as indexOfa2zokh3tu4p6,
  intersect as intersect7qttw6wlmz1n,
  joinToString as joinToString1cxrrlmo0chqs,
  joinTo as joinTo3lkanfaxbzac2,
  lastOrNull as lastOrNull1aq5oz189qoe1,
  last as last1vo29oleiqj36,
  maxWithOrNull as maxWithOrNullsohvqg0i6v8s,
  minOrNull as minOrNull1g8m0136x75mg,
  minus as minus1djrl64vbav3y,
  plus_1 as plus3pcnntex3h8m,
  plus as plus310ted5e4i90h,
  plus_0 as plus20p0vtfmu0596,
  reversed as reversed22y3au42jl32b,
  singleOrNull as singleOrNullrknfaxokm1sl,
  single as singleo93pzdgfc557,
  single_0 as single3ds7xj9roxi5z,
  sortedWith as sortedWith2csnbbb21k0lg,
  sorted as sorted354mfsiv4s7x5,
  take as take3onnpy6q7ctcz,
  toBooleanArray as toBooleanArray2u3qw7fjwsmuh,
  toHashSet as toHashSet1qrcsl3g8ugc8,
  toList as toList3jhuyej2anx2q,
  toMutableList as toMutableList20rdgwi7d3cwi,
  toSet as toSet2orjxp16sotqu,
  union as union28sojvmrkgw6y,
  withIndex as withIndex37cl61h9v5txo,
  zip as zipfdxxupzuj2p9,
};
//endregion

//# sourceMappingURL=_Collections.mjs.map
